import axios, { AxiosResponse } from 'axios';
import {
  UpdatePreferencesInput,
  UpdateFeedReserveInput,
  UpdateConsumptionRateInput,
  UpdateManualInventoryInput,
  UpdateOfdSettingsDataInput,
} from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/ofd-settings-input.type';
import { SkipManualRecommendation } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/skip-manual-recommendation.type';

// Site that was enabled by Loke to work with OFD 2.0 on dev is this one: LOK. ANDHOLMEN - 310693 - SALMAR FARMING AS - 37f13ad1-74ad-4374-8b24-955c7b05491b

// PUT: Update OFD Settings
// /ewosapi/v1/recommendations/settings?globalSiteId=${globalSiteId}
export const updateOfdSiteData = async (
  data: UpdateOfdSettingsDataInput,
  globalSiteId: string
): Promise<UpdateOfdSettingsDataInput> => {
  // return await mockOfdSettingsRequest;
  const res = await axios.put(`/ewosapi/v1/recommendations/settings?globalSiteId=${globalSiteId}`, data);
  return res.data;
};

// PUT: Update Consumption Rate
// /ewosapi/v1/recommendations/settings/consumption-rate?globalSiteId=${globalSiteId}
export const updateConsumptionRate = async (data: UpdateConsumptionRateInput, globalSiteId: string): Promise<AxiosResponse> => {
  // return await mockConsumptionRateUpdateRequest;
  const res = await axios.put(`/ewosapi/v1/recommendations/settings/consumption-rate?globalSiteId=${globalSiteId}`, data);
  return res.data;
};

// PUT: Update Buffer Settings
// /ewosapi/v1/recommendations/settings/buffer?globalSiteId=${globalSiteId}
export const updateFeedReserveSettings = async (data: UpdateFeedReserveInput, globalSiteId: string): Promise<AxiosResponse> => {
  // return await mockBufferSettingsUpdateRequest;
  const res = await axios.put(`/ewosapi/v1/recommendations/settings/buffer?globalSiteId=${globalSiteId}`, data);
  return res.data;
};

// PUT: Update Manual Inventory
// /ewosapi/v1/recommendations/settings/inventory?globalSiteId=${globalSiteId}
export const updateManualInventory = async (data: UpdateManualInventoryInput, globalSiteId: string): Promise<AxiosResponse> => {
  // return await mockManualInventoryUpdateRequest;
  const res = await axios.put(`/ewosapi/v1/recommendations/settings/inventory?globalSiteId=${globalSiteId}`, data);
  return res.data;
};

// PUT: Update Preferences
// /ewosapi/v1/recommendations/settings/preferences?globalSiteId=${globalSiteId}
export const updatePreferencesSettings = async (data: UpdatePreferencesInput, globalSiteId: string): Promise<AxiosResponse> => {
  // return await mockManualInventoryUpdateRequest;
  const res = await axios.put(`/ewosapi/v1/recommendations/settings?globalSiteId=${globalSiteId}`, data);
  return res.data;
};

// PUT: Skip Manual Dispatch
// /ewosapi/v1/recommendations/skip
export const skipManualRecommendation = async (data: SkipManualRecommendation, globalSiteId: string): Promise<AxiosResponse> => {
  const res = await axios.put(`/ewosapi/v1/recommendations/skip?globalSiteId=${globalSiteId}`, data);
  return res.data;
};
